// ---------------------------------------------------------------------------
// icons — centralized icon system
//
// Generic usage (covers 16 static/stateful icons):
//   import { Icon } from '@/components/common/icons';
//   <Icon name="home" size={20} color="currentColor" />
//   <Icon name="chevron" expanded={isOpen} />
//   <Icon name="graph" active={isActive} />
//
// Named usage (special-case icons that can't go through Icon):
//   import { SelectChevronIcon }  from '@/components/common/icons';
//   import { SketchyEllipseIcon } from '@/components/common/icons';
// ---------------------------------------------------------------------------

export { Icon } from './Icon';
export type { IconProps } from './Icon';

export { iconMap } from './icons';
export type { IconName } from './icons';
export type { IconRenderProps } from './types';

// Static / stateful icons (all available via <Icon name="..." /> too)
export { HomeIcon } from './set/HomeIcon';
export { FavoritesIcon } from './set/FavoritesIcon';
export { BurgerIcon } from './set/BurgerIcon';
export { EventsIcon } from './set/EventsIcon';
export { ProfileIcon } from './set/ProfileIcon';
export { DownloadIcon } from './set/DownloadIcon';
export { EyeIcon } from './set/EyeIcon';
export { ArrowLeftIcon } from './set/ArrowLeftIcon';
export { ArrowRightIcon } from './set/ArrowRightIcon';
export { ChevronIcon } from './set/ChevronIcon';
export { SearchIcon } from './set/SearchIcon';
export { GraphIcon } from './set/GraphIcon';
export { TableIcon } from './set/TableIcon';
export { OnlineIcon } from './set/OnlineIcon';
export { PraesenzIcon } from './set/PraesenzIcon';
export { ArrowSmallRightIcon } from './set/ArrowSmallRightIcon';

// Special-case icons — import by name only, not via <Icon name="..." />
export { SelectChevronIcon } from './set/SelectChevronIcon';
export { SketchyEllipseIcon } from './set/SketchyEllipseIcon';
